module.exports = __webpack_public_path__ + "assets/img/teacher (25).c36ffcce.png";